__turbopack_context__.v({
  "bio-block": "biography-module-scss-module__tvcdRa__bio-block",
  "bio-body": "biography-module-scss-module__tvcdRa__bio-body",
  "biography": "biography-module-scss-module__tvcdRa__biography",
  "header-group": "biography-module-scss-module__tvcdRa__header-group",
  "heading": "biography-module-scss-module__tvcdRa__heading",
  "layout": "biography-module-scss-module__tvcdRa__layout",
  "layout--no-video": "biography-module-scss-module__tvcdRa__layout--no-video",
  "show-more-button": "biography-module-scss-module__tvcdRa__show-more-button",
  "show-more-row": "biography-module-scss-module__tvcdRa__show-more-row",
  "social-item": "biography-module-scss-module__tvcdRa__social-item",
  "social-link": "biography-module-scss-module__tvcdRa__social-link",
  "social-links": "biography-module-scss-module__tvcdRa__social-links",
  "video-column": "biography-module-scss-module__tvcdRa__video-column",
  "video-iframe": "biography-module-scss-module__tvcdRa__video-iframe",
  "video-placeholder": "biography-module-scss-module__tvcdRa__video-placeholder",
  "video-play-button": "biography-module-scss-module__tvcdRa__video-play-button",
  "video-thumbnail": "biography-module-scss-module__tvcdRa__video-thumbnail",
  "video-wrapper": "biography-module-scss-module__tvcdRa__video-wrapper",
});
